<template>
  <div class="login">
    <div class="page-title">
      <div class="logo">
        <img
          @click="$router.push('/')"
          :src="imgUrl"
          style="cursor: pointer"
          alt="logo"
          width="100"
        />
      </div>
      <div class="title commonTextRight">Sign In</div>
    </div>
    <div>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="Username"
          prop="username"
          style="font-weight: bold"
          required
        >
          <el-input v-model="form.username" class="inputStyle"></el-input>
        </el-form-item>
        <el-form-item
          label="Password"
          prop="password"
          style="font-weight: bold"
          required
        >
          <el-input
            type="password"
            v-model="form.password"
            autocomplete="off"
            class="inputStyle"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="form.remember"> Keep me logged in</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('form')"
            class="login-btn"
            >Sign In</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="form-helper">
      <a @click="openForgotPassword"> Forgot your password? </a>|
      <a @click="$router.push('/regist')">Register</a>
    </div>
    <ForgotPassword ref="forgotPasswords"></ForgotPassword>
  </div>
</template>

<script>
import { siteInfo } from "@/api/common";
import { login, getRoles } from "@/api/login";
import ForgotPassword from "../model/forgotPassword";
export default {
  name: "LoginComponent",
  components: {
    ForgotPassword,
  },
  data() {
    return {
      imgUrl: "",
      form: {
        username: "",
        password: "",
        remember: true,
      },
      rules: {},
      countryList: [],
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      siteInfo().then((res) => {
        this.imgUrl = res.data.logo.url;
      });
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.form));
          data.remember = data.remember ? "1 " : "";
          login(data).then((res) => {
            if (res.code === 200) {
              localStorage.setItem(
                "userInfo",
                JSON.stringify(res.data.userInfo)
              );
              localStorage.setItem("token", res.data.userInfo.token);
              getRoles({ apiToken: true }).then((res) => {
                if (res.code === 200) {
                  localStorage.setItem(
                    "rolesList",
                    JSON.stringify(res.data.journals)
                  );
                }
              });
              this.$router.push("/");
            } else {
              this.$message.error(res.messages);
            }
          });
        } else {
          console.log("error submit");
          return false;
        }
      });
    },
    openForgotPassword() {
      this.$refs.forgotPasswords.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/commen.css");
.login {
  line-height: 0.5;
  color: #212529;
  text-align: left;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 200;
  width: 497px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1),
    0px 5px 50px 0px rgba(0, 0, 0, 0.1);
  margin: 50px auto;
  padding: 52px 47px 63px;
  @media (max-width: 996px) {
    line-height: 0.4;
    font-size: 13px;
    font-weight: 200;
    width: 90vw !important;
    padding: 30px 27px 23px;
  }
  .page-title {
    font-size: 32px;
    margin-bottom: 0.3em;
    font-weight: 200;
    text-align: left;
    padding: 5px 0;
    .logo {
      width: 100%;
      padding-bottom: 20px;
      border-bottom: 1px dotted #4d4d4d;
      img {
        margin: 0 auto;
        display: flex;
        justify-content: center;
      }
    }
    .title {
      padding-top: 29px;
      padding-bottom: 14px;
    }
  }
  .form-helper {
    text-align: center;
    margin-top: 10px;
    a {
      color: #049bdb;
      margin: 0 5px;
      cursor: pointer;
    }
  }
}
</style>
<style>
.inputStyle .el-input__inner {
  height: 50px;
  line-height: 1;
  border: 1px solid #565656;
}
.login-btn {
  margin-top: 5px;
  margin-bottom: 10px;
  background: linear-gradient(to bottom, #218ae5, #3a9aec, #63b4f6);
  border: 0;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  padding: 18px 20px 17px;
  display: block;
  line-height: 1;
  width: 100%;
}
.login .el-button--primary:focus,
.login .el-button--primary:hover {
  background: linear-gradient(to bottom, #0771cd, #2a9bfb, #3f9fed);
  border-color: #66b1ff;
}
</style>
